import Logo from "@/components/Logo";
import { useSettings } from "@/context/SettingsContext";

export default function AuthShell({ title, subtitle, children }) {
  const { settings } = useSettings();
  return (
    <div className="min-h-screen grid lg:grid-cols-2 bg-white">
      <div className="hidden lg:block relative bg-slate-900">
        <img src="/images/study.jpg" alt="" className="absolute inset-0 h-full w-full object-cover opacity-40" />
        <div className="relative h-full flex flex-col justify-between p-12">
          <Logo dark />
          <div>
            <p className="eyebrow text-amber-400">{settings?.page_title}</p>
            <p className="font-display text-4xl font-bold text-white mt-4 leading-tight max-w-md" data-testid="auth-quote">{settings?.auth_quote}</p>
          </div>
        </div>
      </div>
      <div className="flex items-center justify-center p-6 sm:p-12">
        <div className="w-full max-w-md fade-up">
          <div className="lg:hidden mb-10"><Logo /></div>
          <h1 className="text-3xl sm:text-4xl font-extrabold tracking-tight text-slate-900">{title}</h1>
          {subtitle && <p className="mt-3 text-slate-600">{subtitle}</p>}
          <div className="mt-8">{children}</div>
        </div>
      </div>
    </div>
  );
}
